import React from 'react';
import {ScaleLinear, ScaleTime} from 'd3-scale';
import {line} from 'd3-shape';
import {Property} from 'csstype';
import {DataPoint} from '../../types';

interface Props {
  data: DataPoint[];
  color: Property.Color;
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
  dashed?: boolean;
}

export default class SimpleLineSeries extends React.Component<Props> {
  render() {
    const {data, color, xScale, yScale, dashed = false, ...props} = this.props;

    const l = line<DataPoint>()
      .x(d => xScale(d.date)!)
      .y(d => yScale(d.value)!);

    const path = l(data);

    if (!path) return null;

    return (
      <path
        d={path}
        stroke={color}
        strokeDasharray={dashed ? '4 3' : ''}
        fill="none"
        strokeWidth={2}
        cursor={'auto'}
        {...props}
      />
    );
  }
}
